/* global CustomEvent */

const getPosition = event => ({
  x: (event.touches && event.touches[0].pageX) || event.pageX,
  y: (event.touches && event.touches[0].pageY) || event.pageY
})

export default {
  bind (el, { value }) {
    let grabFlag = false
    let x = null
    let y = null
    let dragInProcess = false
    let detail = null

    const start = event => {
      grabFlag = true
      const pos = getPosition(event)
      x = pos.x
      y = pos.y
    }

    const click = event => {
      if (dragInProcess) {
        event.stopPropagation()
        event.preventDefault()
      }
    }

    const cancel = () => {
      grabFlag = false
      x = null
      y = null
    }

    const dragStart = event => {
      if (value === false || value === null) {
        return
      }
      if (!grabFlag) return
      const pos = getPosition(event)
      const d2 = (pos.x - x) ** 2 + (pos.y - y) ** 2
      if (d2 <= 5 ** 2) return

      cancel()
      dragInProcess = true
      detail = el.dataset.drag
      el.dispatchEvent(new CustomEvent('drag-start', {
        bubbles: true,
        detail
      }))

      document.addEventListener('mousemove', dragOver)
      document.addEventListener('touchmove', dragOver)
      document.addEventListener('mouseup', dragEnd)
      document.addEventListener('touchend', dragEnd)
    }

    const dragOver = event => {
      if (value === false || value === null) {
        return
      }
      event.preventDefault()
      event.target.dispatchEvent(new CustomEvent('drag-over', {
        bubbles: true,
        detail
      }))
    }

    const dragEnd = event => {
      if (value === false || value === null) {
        return
      }
      event.target.dispatchEvent(new CustomEvent('drag-end', {
        bubbles: true,
        detail
      }))

      detail = null
      setTimeout(() => {
        dragInProcess = false
      }, 0)

      document.removeEventListener('mouseup', dragEnd)
      document.removeEventListener('touchend', dragEnd)

      document.removeEventListener('mousemove', dragOver)
      document.removeEventListener('mousemove', dragOver)
      document.removeEventListener('touchmove', dragOver)
    }

    el.addEventListener('mousedown', start)
    el.addEventListener('touchstart', start)

    el.addEventListener('mouseup', cancel)
    el.addEventListener('touchend', cancel)

    el.addEventListener('mousemove', dragStart)
    el.addEventListener('touchmove', dragStart)

    el.addEventListener('click', click)
  }
}



// WEBPACK FOOTER //
// ./src/client/lib/v-draggable.js